/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { SubPage, Copy, Title, CTAs, Button, Form, Grid, GridSet, GridItem, TextField, CheckboxField, SaveButton } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/account/users/adduser/adduser_styles';



/* ========== ~~~~~~~~~~ ACCOUNT EDIT USER ~~~~~~~~~~ ========== */
class AddUser extends Component {
    constructor(props) {
        super(props);
        this.permissions = {
            edit_payment: 'settings.paymentInfo',
            change_permissions: 'settings.users',
            manage_sites: 'settings.sites',
            account_information: 'settings.general',
            adstxt: 'settings.adsTxt',
            create_embeds: 'manageEmbeds',
            home_adMetrics: 'home.adMetrics'
        };
        this.formName = 'addUser';
    }
    componentWillUnmount() {
        this.props.resetForm(this.formName)
    }
    handleSave = () => {
        this.props.addUser(this.props.fields, this.formFieldData(), this.props.accountUUID, this.handleSaveSuccess)
    };
    handleSaveSuccess = response => {
        this.props.addUserToTable(response);
        this.props.displayModal(false);
    };
    formFieldData = () => {
        let formData = {
            firstName: this.props.fields.fname.value,
            lastName: this.props.fields.lname.value,
            email: this.props.fields.email.value,
            phoneNumber: this.props.fields.phone.value,
            permissions: []
        };
        //loop permission fields and push appropriate values in to permissions array
        Object.keys(this.permissions).map(item => this.props.fields[item].value ? formData.permissions.push(this.permissions[item]) : null);

        return formData;
    };
    handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.handleSave();
        }
    }

    render() {
        //deconstructing fields object from props
        const {
            fname, lname, email, phone,
            edit_payment, change_permissions,
            manage_sites,
            account_information, adstxt,
            create_embeds, home_adMetrics
        } = this.props.fields;

        return (

            <SubPage name={`adduser`} klass={this.props.classes.adduser}>
                <Form name={this.formName} editable={this.props.editable} processing={this.props.savingData} handleKeyDown={this.handleKeyDown}>
                    <Copy>
                        <Title size={`medium`}>
                            <h2>Add User</h2>
                        </Title>
                    </Copy>
                    <Grid direction={`horizontal`} type={`fields`}>
                        <GridSet direction={`vertical`}>
                            <GridItem><TextField type={`text`} formName={this.formName} name={`fname`} value={fname.value} valid={fname.valid} placeholder={`First Name`} label={`First Name`} info={``} required /></GridItem>
                            <GridItem><TextField type={`text`} formName={this.formName} name={`lname`} value={lname.value} valid={lname.valid} placeholder={`Last Name`} label={`Last Name`} info={``} required /></GridItem>
                            <GridItem><TextField type={`email`} formName={this.formName} name={`email`} value={email.value} valid={email.valid} placeholder={`Email`} label={`Email`} info={``} validateOnChange required /></GridItem>
                            <GridItem><TextField type={`tel`} formName={this.formName} name={`phone`} value={phone.value} valid={phone.valid} placeholder={`Phone`} label={`Phone`} info={``} validateOnChange required /></GridItem>
                        </GridSet>
                        <GridSet direction={`vertical`} >
                            <div className={`permissionslabel`}>Permissions</div>
                            <GridItem><CheckboxField type={`checkbox`} formName={this.formName} name={`edit_payment`} checked={edit_payment.value} valid={true} label={`Edit Payment Information`} /></GridItem>
                            <GridItem><CheckboxField type={`checkbox`} formName={this.formName} name={`change_permissions`} value={`change_permissions`} checked={change_permissions.value} valid={true} label={`Change user permissions`} handleChange={this.handleCheckBox} /></GridItem>
                            <GridItem><CheckboxField type={`checkbox`} formName={this.formName} name={`manage_sites`} checked={manage_sites.value} valid={true} label={`Manage sites`} /></GridItem>
                            <GridItem><CheckboxField type={`checkbox`} formName={this.formName} name={`account_information`} checked={account_information.value} valid={true} label={`Edit account information`} /></GridItem>
                            <GridItem><CheckboxField type={`checkbox`} formName={this.formName} name={`adstxt`} checked={adstxt.value} valid={true} label={`Manage Ads.txt file`} /></GridItem>
                            <GridItem><CheckboxField type={`checkbox`} formName={this.formName} name={`create_embeds`} checked={create_embeds.value} valid={true} label={`Create, edit, and view embeds`} /></GridItem>
                            <GridItem><CheckboxField type={`checkbox`} formName={this.formName} name={`home_adMetrics`} checked={home_adMetrics.value} valid={true} label={`Embed Analytics - Ad Metrics`} /></GridItem>
                        </GridSet>
                    </Grid>
                    <CTAs name={`ctas`}>
                        <Button type={`modal`} action={false} variant={`delete`} name={`cancel`} text={`Cancel`} />
                        <SaveButton savingData={this.props.savingData} handleSave={this.handleSave} />
                    </CTAs>
                </Form>
            </SubPage>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(AddUser);
